import { render, staticRenderFns } from "./SyncList.vue?vue&type=template&id=311b5a0e&scoped=true"
import script from "./SyncList.vue?vue&type=script&setup=true&lang=ts"
export * from "./SyncList.vue?vue&type=script&setup=true&lang=ts"
import style0 from "./SyncList.vue?vue&type=style&index=0&id=311b5a0e&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "311b5a0e",
  null
  
)

export default component.exports